
// 画像ポップアップ
 $('a.js-magnific').magnificPopup({
    type: 'image'
 });

// 画像ポップアップ
 $('a.js-magnific').magnificPopup({
    type: 'image'
});

    // ギャラリー
$('a.js-gallerypop').magnificPopup({
    preloader: true,
    type: 'image',
    gallery: {
        enabled: true
    }
});

// youtube用ポップアップ
$('a.js-youtube').magnificPopup({
    // disableOn: 700,
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
    type: 'iframe',
    iframe: {
        patterns: {
            youtube: {
                index: 'youtube.com',
                id: 'v=',
                src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1'
            }
        }
    }
});




//////////////////
// WEBPACK FOOTER
// ./js/module/popup.js
// module id = 7
// module chunks = 0